import {
  Dropdown,
  Field as Field2,
  Item,
  Menu,
  Select
} from "@zendeskgarden/react-dropdowns";
import {
  Field,
  Field as ToggleField,
  Input,
  Label,
  MediaInput,
  Message,
  Toggle
} from "@zendeskgarden/react-forms";
import { Dots } from "@zendeskgarden/react-loaders";
import { ReactComponent as LockIcon } from "@zendeskgarden/svg-icons/src/16/lock-locked-fill.svg";
import { ReactComponent as UnlockIcon } from "@zendeskgarden/svg-icons/src/16/lock-unlocked-fill.svg";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { currentLanguageChanged } from "../../actions";
import HeaderMobile from "../../components/header";
// import SEO from "../../components/seo";
import { UserData } from "../../model/user.model";
import { LOGIN_ROUTE, TERMS_OF_USE_ROUTE, SIGNUP_SUCCESS_ROUTE } from "../../providers/routes";
import TranslationService, { t } from "../../translations/translation.service";
// @ts-ignore
import "./index.css";
import UserService from "../../services/user.service";
import Phone from "../professional/view/components/phone/phone";
import LogoElumini from "../../components/logoElumini";
// @ts-ignore
import ReactFilestack from "filestack-react";
import { AlertService } from '../../services/alert.service';
import { AuthenticationService } from "../../services/auth.service";
// Ajuste o caminho conforme necessário

import CvUploadAutoFill from '../../components/cv-upload-autofill';
import AzureCitySelect from "../professional/view/components/maps/AzureCitySelect";


let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

class Signup extends React.Component<any> {
  fileInputRef: React.RefObject<HTMLInputElement>;

  state = {
    currentLang: TranslationService.getCurrentLanguage,
    user: {
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      pcd: false,
      contato: "",
      geolocation: "",
      address: {
        city: "",
        state: "",
        country: "",
        label: "",
      } as {
        city: string;
        state: string;
        country: string;
        label: string;
      } | null,
      fileName: "",
      files: [],
      policyAndSignature: "",
      linkedinUrl: "", // Adicione aqui
      vagaId: "", // ou undefined
      europeanUnionCitizenship: false,
    },
    width: window.innerWidth,
    lock: true,
    firstNameValid: true,
    lastNameValid: true,
    emailValid: true,
    checkEmailExists: false,
    passwordValid: true,
    inputPassword: "password",
    formValid: false,
    loadingSubmit: false,
    emailTouched: false, // Adicione esta linha
    locationValid: true,
    phoneInputError: "",
    policyString: "",
    signatureString: "",
  };

  constructor(props: any) {
    super(props);
    this.fileInputRef = React.createRef<HTMLInputElement>();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.includeLocation = this.includeLocation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.lockPassword = this.lockPassword.bind(this);
  }

  
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  async componentDidMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
    const { currentLanguageChanged } = this.props;
    currentLanguageChanged(this.state.currentLang);

       // Busque policy e signature
    const FileStackService = (await import("../../services/filestack.service")).default;
    try {
      const policyAndSignature = await FileStackService.getPoliceAndSignature();
      this.setState({
        policyString: policyAndSignature.data.policy,
        signatureString: policyAndSignature.data.signature
      });
    } catch (err) {
      console.log("ERROR: ", err);
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, _prevState: Readonly<{}>): void {
    if (
        this.state.width <= 680 &&
        prevProps.currentLanguage !== this.props.currentLanguage
        && typeof(this.props.currentLanguage) !== "function"
      ) {
      this.setState({ currentLang: this.props.currentLanguage});
    }
  }

  handleSubmit(event: any) {
    this.setState({ loadingSubmit: true, emailTouched: true }, () => this.lockPassword(true));
    event.preventDefault();

    const userData: Partial<UserData> = {
      email: this.state.user.email.toLowerCase(),
      firstName: this.state.user.firstName,
      lastName: this.state.user.lastName,
      password: this.state.user.password,
      attachments: this.state.user.files,
      dadosPessoais: {
        pcdUser: {
          isUserPCD: false, 
          defs: [],
          cidCode: undefined,
        },
        localidade: this.state.user.address?.label || "",
        geolocation_formatted: this.state.user.address?.label || "",
        geolocation: this.state.user.geolocation,
        indicadoPor: undefined,
      },
      contato: this.state.user.contato,
      vagaId: this.state.user.vagaId,
      europeanUnionCitizenship: this.state.user.europeanUnionCitizenship,
      policyAndSignature: this.state.user.policyAndSignature
    };

    AuthenticationService.signup(userData, TranslationService.getCurrentLanguage())
      .then((data: any) => {
        if (data.message === "PROFESSIONAL_REGISTERED_WITH_SUCCESS") {
          this.props.history.push({
            pathname: SIGNUP_SUCCESS_ROUTE,
            data: userData.email,
          });
        } else {
          AlertService.error(
            t("Sistema indisponível, por favor tente novamente mais tarde.")
          );
        }
      })
      .catch((error: any) => {
        if (error?.response?.data?.message) {
          if (error.response.data.message === "EMAIL_ALREADY_REGISTERED") {
            AlertService.error("Email já cadastrado");
          } else {
            AlertService.error(
              t("Sistema indisponível, por favor tente novamente mais tarde.")
            );
          }
        } else {
          AlertService.error(
            t("Sistema indisponível, por favor tente novamente mais tarde.")
          );
        }
      })
      .finally(() => {
        this.setState({ loadingSubmit: false });
      });
  }

  handleEmailBlur(event: any) {
    const target = event.target;
    const value = target.value;
    if (!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ) {
      return;
    }
    UserService.checkEmail(value).then((response:any) => {
      if (response.data.exists) {
        this.setState({ checkEmailExists: true });
        return;
      }
      this.setState({ checkEmailExists: false });

    });
  }


  lockPassword(value: boolean) {
    this.setState({ lock: value, inputPassword: value ? "password" : "text" });
  }

  handleInputChange(event: any) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState(
      {
        user: {
          ...this.state.user,
          [name]: value,
        },
      },
      () => {
        this.validateField(name, value);
      }
    );
  }

  validateField(fieldName: string, value: any) {
    let { firstNameValid, lastNameValid, emailValid, passwordValid } = this.state;

    switch (fieldName) {
      case "email":
        emailValid = !!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i); 
        break;
      case "password":
        passwordValid = value.length >= 8;
        break;
      case "firstName":
        firstNameValid = value.length >= 3;
        break;
      case "lastName":
        lastNameValid = value.length >= 3;
        break;
      default:
        break;
    }
    this.setState(
      {
        firstNameValid,
        lastNameValid,
        emailValid,
        passwordValid,
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState((prevState: any) => ({
      formValid: !!(
        prevState.emailValid &&
        prevState.user.email &&
        prevState.passwordValid &&
        prevState.user.password &&
        prevState.firstNameValid &&
        prevState.user.firstName &&
        prevState.lastNameValid &&
        prevState.user.lastName &&
        prevState.user.contato &&
        prevState.phoneInputError === ""
      ),
    }));
  }

includeLocation(data: any) {
  if (!data) {
    this.setState((prevState: any) => ({
      user: {
        ...prevState.user,
        geolocation: undefined,
        address: {
          city: "",
          state: "",
          country: "",
          label: "",
        },
      },
      locationValid: false,
    }), () => this.validateForm());
    return;
  }

  const geolocation =
    data.position?.lat != null && data.position?.lon != null
      ? { lat: data.position.lat, lng: data.position.lon }
      : undefined;

  this.setState(
    (prevState: any) => ({
      user: {
        ...prevState.user,
        geolocation,
        address: {
          city: data.city || "",
          state: data.state || "",
          country: data.country || "",
          label: data.label || "",
        },
      },
      locationValid: !!data.city,
    }),
    () => this.validateForm()
  );
}

  onFiles = async ({ filesUploaded }: any) => {
    const array = filesUploaded.map((item: any) => ({
      fileName: item.filename,
      url: item.url,
    }));
    // Se precisar buscar policyAndSignature para o arquivo, faça aqui
    this.setState((prevState: any) => ({
      user: { ...prevState.user, fileName: array[0].fileName, files: array },
    }), () => this.validateForm());
  };

 handleCvExtractedData = (data: any) => {
  this.setState((prevState: any) => {
        let updatedUser: any = {
      ...prevState.user,
      firstName: data.name || data.firstName || prevState.user.firstName,
      lastName: data.lastName || prevState.user.lastName,
      email: data.email || prevState.user.email,
      contato: data.phone || prevState.user.contato,
      address: data.address || prevState.user.address,
      linkedinUrl: data.linkedinUrl || prevState.user.linkedinUrl,
    };
    if (data.files && data.files.length > 0) {
      updatedUser.files = data.files;
      updatedUser.fileName = data.fileName;
      updatedUser.policyAndSignature = data.policyAndSignature;
    }
    return { user: updatedUser };
  }, this.validateForm);
};

  render() {
    const { width } = this.state;
    const isMobile = width <= 680;
    const { currentLanguageChanged } = this.props;
    const langs = TranslationService.getLanguages();

    if (!isMobile) {
      return (
        <>
          {/* <SEO title={`Enter - ${t("Cadastre-se")}`} url='https://elumini.enter.jobs/signup'/> */}
          <div className="bg-enter  d-flex align-items-center justify-content-center">
            <div className="d-flex justify-items-center">
              <div className="bg-container-signup">
                <div className="content-signup d-flex justify-content-between justify-items-center flex-column">
                  <div>
                    <div className="row">
                      <div className="col">
                        <LogoElumini />
                      </div>
                      <div className="d-flex align-items-center  sm mb-1 mt-1">
                        <Dropdown
                          selectedItem={TranslationService.getCurrentLanguage()}
                          onSelect={(selectedLang) => {
                            TranslationService.changeLanguage(selectedLang);
                            this.setState({ currentLang: selectedLang });
                            currentLanguageChanged(selectedLang);
                          }}
                          downshiftProps={{
                            itemToString: (item: any) => item,
                          }}
                        >
                          <Field2>
                            <Select className="u-semi u-fs-sm border-0">
                              {t(TranslationService.getCurrentLanguage())}
                            </Select>
                          </Field2>
                          <Menu className="u-fs-sm">
                            {langs.map((option: any) => (
                              <Item key={option} value={option}>
                                {t(option)}
                              </Item>
                            ))}
                          </Menu>
                        </Dropdown>
                      </div>
                    </div>
                      <CvUploadAutoFill
                        onExtractedData={this.handleCvExtractedData}
                        onError={(msg: string) => AlertService.error(msg)}
                        unauthenticated
                      />
                    <form className="login-body" onSubmit={this.handleSubmit}>
                      <h1 className="signup-title">{t("Cadastre-se")}</h1>
                      <Field className="mt-1">
                        <Input
                          disabled={this.state.loadingSubmit}
                          validation={
                            this.state.firstNameValid ? undefined : "error"
                          }
                          onChange={this.handleInputChange}
                          value={this.state.user.firstName}
                          name="firstName"
                          placeholder={t("Nome")}
                        ></Input>
                        {!this.state.firstNameValid && (
                          <Message validation="error">
                            {t("Nome inválido.")}
                          </Message>
                        )}
                      </Field>

                      <Field className="mt-1">
                        <Input
                          disabled={this.state.loadingSubmit}
                          validation={
                            this.state.lastNameValid ? undefined : "error"
                          }
                          onChange={this.handleInputChange}
                          value={this.state.user.lastName}
                          name="lastName"
                          placeholder={t("Sobrenome")}
                        ></Input>
                        {!this.state.lastNameValid && (
                          <Message validation="error">
                            {t("Sobrenome inválido.")}
                          </Message>
                        )}    
                      </Field> 
                      <Field className="mt-1">
                        <Input
                          disabled={this.state.loadingSubmit}
                          validation={
                            this.state.emailTouched && !this.state.user.email
                              ? "error"
                              : this.state.emailValid
                              ? this.state.checkEmailExists
                                ? "error"
                                : undefined
                              : "error"
                          }
                          onChange={this.handleInputChange}
                          onBlur={this.handleEmailBlur.bind(this)}
                          value={this.state.user.email}
                          name="email"
                          placeholder={t("E-mail")}
                        />
                        <div className="validation-messages">
                          {this.state.emailTouched && !this.state.user.email ? (
                            <Message validation="error">{t("Email obrigatório!")}</Message>
                          ) : !this.state.emailValid ? (
                            <Message validation="error">
                              {t("Email inválido.")}
                              </Message>
                          ) : this.state.checkEmailExists ? (
                            <Message validation="error">
                              {t("Email já cadastrado.")}
                              </Message>
                          ) : null}
                        </div>
                      </Field>
                      <Field className="mt-1">
                        <Label style={{ width: "100%" }}>
                        <AzureCitySelect
                           onChange={this.includeLocation}
                           currentLanguage={TranslationService.getCurrentLanguage()}
                           placeholder={t("Local de Residência")}
                        />
                        </Label>
                    </Field>
                    <Phone
                      value={this.state.user.contato}
                      onChange={(telefoneAtualizado: any) =>
                        this.setState(
                          (prevState: any) => ({
                            user: {
                              ...prevState.user,
                              contato: telefoneAtualizado.contato,
                            },
                          }),
                          () => this.validateForm()
                        )
                      }
                      onError={(msg: string) =>
                        this.setState({ phoneInputError: msg }, () => this.validateForm())
                      }
                    />
                  <Field>
                      <Label className="" style={{ fontSize: '9px' }}>{t("Upload do Currículo")}</Label>
                      {this.state.policyString && this.state.policyString.length > 0 && (
                        <ReactFilestack
                          apikey={process.env.REACT_APP_FILESTACK_API}
                          componentDisplayMode={{
                            type: "button",
                            customText: <span style={{ fontSize: "8px" }}>{t("Arquivos PDF ou DOCX de até 5MB")}</span>,
                            customClass: "c-txt__input",
                            style: { fontSize: "8px"}
                          }}
                          actionOptions={{
                            accept: [".pdf", ".docx"],
                            maxFiles: 1,
                            maxSize: 5 * 1024 * 1024, // 5MB
                          }}
                          clientOptions={{
                            security: {
                              policy: this.state.policyString,
                              signature: this.state.signatureString,
                            },
                          }}
                          onSuccess={this.onFiles}
                        />
                      )}
                      {this.state.user.fileName && (
  <Message validation="success">
    Currículo carregado automaticamente: {this.state.user.fileName}
  </Message>
)}
                    </Field>

                      <Field className="mt-1">
                        <MediaInput
                          name="password"
                          disabled={this.state.loadingSubmit}
                          validation={
                            this.state.passwordValid ? undefined : "error"
                          }
                          type={this.state.inputPassword}
                          onChange={this.handleInputChange}
                          onBlur={this.handleInputChange}
                          placeholder={t("Senha")}
                          end={
                            <React.Fragment>
                              {!this.state.lock && (
                                <UnlockIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.lockPassword(true)}
                                ></UnlockIcon>
                              )}
                              {this.state.lock && (
                                <LockIcon
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.lockPassword(false)}
                                ></LockIcon>
                              )}
                            </React.Fragment>
                          }
                        />
                        {!this.state.passwordValid && (
                          <Message validation="error">
                            {t("Senha inválida.")}
                          </Message>
                        )}
                      </Field>
                      <ToggleField className="text-left align-items-center">
                        <Toggle
                          name="pcd"
                          onChange={(e) =>
                            this.setState({
                              user: { ...this.state.user, pcd: e.target.checked },
                            })
                          }
                        >
                          <Label className="pcd-toggle">{`${t(
                            "Pessoa com deficiência"
                          )}`}</Label>
                        </Toggle>
                      </ToggleField>
                      <ToggleField className="text-left align-items-center">
                        <Toggle
                          name="europeanUnionCitizenship"
                          onChange={(e) =>
                            this.setState({
                              europeanUnionCitizenship: e.target.checked,
                            })
                          }
                        >
                          <Label className="pcd-toggle">{`${t(
                            "Cidadania Europeia"
                          )}`}</Label>
                        </Toggle>
                      </ToggleField>
                           <button
                               type="submit"
                               disabled={!this.state.formValid || this.state.loadingSubmit}
                               className="btn-enviar-signup w-100 button-entrar"
                             >
                               {!this.state.loadingSubmit && t("Cadastrar")}
                               {this.state.loadingSubmit && (
                                 <Dots
                                   key="dots-loading"
                                   color="var(--color-primary)"
                                   size="32px"
                                 />
                               )}
                             </button>                          
                            <p className="text-center" style={{ fontSize: '9px' }}>
                              {t("Ao clicar em Aceitar e cadastrar, você aceita os ")}
                              <a
                                href={TERMS_OF_USE_ROUTE}
                                className="u-semibold u-fg-grey-500"
                              >
                                {t("Termos de Uso do Enter.")}
                              </a>
                            </p>
                               <p
                 
                      className="text-center u-fg-grey-500"
                    >
                      {t("Já é cadastrado?")}{" "}
                      <a href={LOGIN_ROUTE} className="u-semibold u-fg-grey-600">
                        {t("Clique aqui para entrar")}
                      </a>
                    </p>
    
                   
                    </form>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <HeaderMobile />
          <div className="login-body bg-enter p-4 d-flex flex-column">
            <div className="container">
              <h1 className="login-title mt-0 text-light">
                {t("Cadastre-se")}
              </h1>
              <form className="login-body" onSubmit={this.handleSubmit}>
                <Field className="mt-3">
                  <Input
                    disabled={this.state.loadingSubmit}
                    validation={this.state.firstNameValid ? undefined : "error"}
                    onChange={this.handleInputChange}
                    value={this.state.user.firstName}
                    name="firstName"
                    placeholder={t("Nome")}
                  ></Input>
                  {!this.state.firstNameValid && (
                    <Message validation="error">{t("Nome inválido.")}</Message>
                  )}
                </Field>
                <Field className="mt-3">
                  <Input
                    disabled={this.state.loadingSubmit}
                    validation={this.state.lastNameValid ? undefined : "error"}
                    onChange={this.handleInputChange}
                    value={this.state.user.lastName}
                    name="lastName"
                    placeholder={t("Sobrenome")}
                  ></Input>
                  {!this.state.lastNameValid && (
                    <Message validation="error">
                      {t("Sobrenome inválido.")}
                    </Message>
                  )}
                </Field>
                <Field className="mt-2">
                  <Input
                    disabled={this.state.loadingSubmit}
                    validation={
                      this.state.emailTouched && !this.state.user.email
                        ? "error"
                        : this.state.emailValid
                        ? this.state.checkEmailExists
                          ? "error"
                          : undefined
                        : "error"
                    }
                    onChange={this.handleInputChange}
                    onBlur={this.handleEmailBlur.bind(this)}
                    value={this.state.user.email}
                    name="email"
                    placeholder={t("E-mail")}
                  />
                  <div className="validation-messages">
                    {this.state.emailTouched && !this.state.user.email ? (
                      <Message validation="error">{t("Email obrigatório!")}</Message>
                    ) : !this.state.emailValid ? (
                      <Message validation="error">{t("Email inválido.")}</Message>
                    ) : this.state.checkEmailExists ? (
                      <Message validation="error">{t("Email já cadastrado.")}</Message>
                    ) : null}
                  </div>
                </Field>
                <Field className="mt-2">
                        <Label style={{ width: "100%" }}>
                        <AzureCitySelect
                           onChange={this.includeLocation}
                           currentLanguage={TranslationService.getCurrentLanguage()}
                           placeholder={t("Local de Residência")}
                        />
                      </Label>
                        {!this.state.locationValid && (
                          <Message validation="error">
                            {t("Local inválido.")}
                          </Message>
                        )}
                    </Field> 
                      <Phone
                      value={this.state.user.contato}
                      onChange={(telefoneAtualizado: any) =>
                        this.setState(
                          (prevState: any) => ({
                            user: {
                              ...prevState.user,
                              contato: telefoneAtualizado.contato,
                            },
                          }),
                          () => this.validateForm()
                        )
                      }
                      onError={(msg: string) =>
                        this.setState({ phoneInputError: msg }, () => this.validateForm())
                      }
                    /> 
                      <CvUploadAutoFill
                        onExtractedData={this.handleCvExtractedData}
                        onError={(msg: string) => AlertService.error(msg)}
                        unauthenticated
                      />
                    
                    <Field>
                      <Label className="mt-4">{t("Upload do Currículo")}</Label>
                      {this.state.policyString && this.state.policyString.length > 0 && (
                        <ReactFilestack
                          apikey={process.env.REACT_APP_FILESTACK_API}
                          componentDisplayMode={{
                            type: "button",
                            customText: t("Arquivos PDF ou DOCX de até 5MB"),
                            customClass: "c-txt__input",
                          }}
                          actionOptions={{
                            accept: [".pdf", ".docx"],
                            maxFiles: 1,
                            maxSize: 5 * 1024 * 1024, // 5MB
                          }}
                          clientOptions={{
                            security: {
                              policy: this.state.policyString,
                              signature: this.state.signatureString,
                            },
                          }}
                          onSuccess={this.onFiles}
                        />
                      )}
                      <small className="c-txt__message c-txt__message--success">
                        {this.state.user.fileName}
                      </small>
                    </Field>
                <Field className="mt-3">
                  <MediaInput
                    name="password"
                    disabled={this.state.loadingSubmit}
                    validation={this.state.passwordValid ? undefined : "error"}
                    type={this.state.inputPassword}
                    onChange={this.handleInputChange}
                    placeholder={t("Senha")}
                    end={
                      <React.Fragment>
                        {!this.state.lock && (
                          <UnlockIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => this.lockPassword(true)}
                          ></UnlockIcon>
                        )}
                        {this.state.lock && (
                          <LockIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => this.lockPassword(false)}
                          ></LockIcon>
                        )}
                      </React.Fragment>
                    }
                  />
                  {!this.state.passwordValid && (
                    <Message validation="error">{t("Senha inválida.")}</Message>
                  )}
                </Field>

                <ToggleField className="text-left mt-3 align-items-center">
                  <Toggle
                    name="pcd"
                    onChange={(e) =>
                      this.setState({
                        user: { ...this.state.user, pcd: e.target.checked },
                      })
                    }
                  >
                    <Label className="pcd-toggle">{`${t(
                      "Pessoa com deficiência"
                    )}`}</Label>
                  </Toggle>
                </ToggleField>
                <ToggleField className="text-left mt-3 align-items-center">
                  <Toggle
                    name="europeanUnionCitizenship"
                    onChange={(e) =>
                      this.setState({
                        europeanUnionCitizenship: e.target.checked,
                      })
                    }
                  >
                    <Label className="pcd-toggle">{`${t(
                      "Cidadania Europeia"
                    )}`}</Label>
                  </Toggle>
                </ToggleField>
                              <button
                               type="submit"
                               disabled={!this.state.formValid || this.state.loadingSubmit}
                               className="btn-enviar-signup w-100 button-entrar"
                             >
                               {!this.state.loadingSubmit && t("Cadastrar")}
                               {this.state.loadingSubmit && (
                                 <Dots
                                   key="dots-loading"
                                   color="var(--color-primary)"
                                   size="32px"
                                 />
                               )}
                             </button>  
                                 <p className="text-center u-fs-md mt-2 mx-2 text-light">
                                   {t("Ao clicar em Aceitar e cadastrar, você aceita os ")}
                                   <a href={TERMS_OF_USE_ROUTE} className="u-semibold">
                                     {t("Termos de Uso do Enter.")}
                                   </a>
                                 </p>
                               </form>
                             </div>
                             <div className="text-light">
                               <p className="text-center u-fs-md mb-0 px-2">
                                 {t("Somos muito cuidadosos com seus dados.")}
                               </p>
                               <p className="text-center u-fs-md mt-0 px-5">
                                 {t("Veja nossa ")}
                                 <a href={TERMS_OF_USE_ROUTE} className="u-semibold">
                                   {t("Política de Privacidade")}
                                 </a>
                               </p>
                             </div>
                             <p className="text-center u-fs-md mt-2 mx-2 text-light">
                               {t("Já é cadastrado?")}{" "}
                               <a href={LOGIN_ROUTE} className="u-semibold text-light">
                                 {t("Clique aqui para entrar")}
                               </a>
                             </p>
                           </div>
          {/* <pre>{JSON.stringify(this.state.user, null, 2)}</pre> */}
        </>
      );
    }
  }
}

const mapStateToProps = (store: {
  changeLanguageReducer: { currentLanguage: string };
}) => ({
  currentLanguage: store.changeLanguageReducer.currentLanguage,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      currentLanguageChanged,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Signup));
